import React from "react";
import { format } from "date-fns";

const ActivityLogCards = ({ logs = [] }) => {
  return (
    <div>
      {logs.map((log, index) => {
        const removeBoldMarkers = log?.details?.replace(/\*\*/g, "");
        return (
          <div
            key={index}
            className="bg-white shadow-[0px_0px_8px_0px_rgba(0,0,0,0.16)] rounded-lg p-4 mb-4 w-full"
          >
            <div className="flex justify-between items-center w-full">
              <div className="flex flex-col items-start min-w-fit gap-1">
                <div className="font-medium text-[0.95rem] text-black">Date</div>
                <div className="text-black font-normal text-[0.85rem]">
                  {log?.date ? format(new Date(log.date), "dd/MM/yy") : "N/A"}
                </div>
              </div>
              <div className="p-[0.3rem] w-[8rem] min-w-fit text-[#0068FF] rounded-[15px] font-normal text-[0.8rem] border !border-[#0068FF] flex items-center justify-center">
                {log?.action_label || "N/A"}
              </div>
            </div>
            <div className="flex flex-col mt-4 gap-1">
              <div className="font-medium text-[0.95rem] text-black">Details</div>
              <div
                title={removeBoldMarkers}
                className="text-[#555555] font-normal text-[0.9rem] break-words"
              >
                {log?.details?.split(/(\*\*.*?\*\*)/g).map((part, index) =>
                  part.startsWith("**") && part.endsWith("**") ? (
                    <span className="font-medium text-black" key={index}>
                      "{part.slice(2, -2)}"
                    </span>
                  ) : (
                    part
                  ),
                )}
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default ActivityLogCards;
